<div class="row user">
  <div class="col-md-12">
    <div class="profile">
      <div class="info"><img class="user-img" src="{{applicant.PhotoUrl}}">
        <h4>{{applicant?.Title}} {{applicant?.LastName}}</h4>
        <p>{{applicant?.StudentNumber}}</p>
      </div>
      <div class="cover-image"></div>
    </div>
  </div>
  <div class="col-md-3">
    <div class="tile p-0">
      <ul class="nav flex-column nav-tabs user-tabs">
        <li class="nav-item"><a class="nav-link active" href="#user-timeline" data-toggle="tab">Welcome To UMaT</a></li>
      </ul>
    </div>
  </div>
  <div class="col-md-9">
    <div class="tab-content">
      <div class="tab-pane active" id="user-timeline">
        <div class="timeline-post">

          <h3 class="tile-title main-text">Offer of Admission to {{admittedApplicant?.ProgrammeFullName}}</h3>
          <hr />
          <div class="tile-body">
            <b>Full Name</b>
            <p>{{admittedApplicant?.ApplicatantFullName}}</p>
            <b>Fee Status</b>
            <p>{{admittedApplicant?.ProgrammeFunding}}</p>
            <b>Hall</b>
            <p>{{admittedApplicant?.Hall}}</p>
          </div>
          <br />
          
          <div class="tile-footer">
            <button class="btn btn-primary" (click)="onDownloadAdmissionLetter()">Download Admission Letter</button>
            <button class="btn btn-secondary" (click)="onDownloadFeeSchedule()">Download Fee Schedule</button>
            <button class="btn btn-danger" (click)="onDownloadItems()">Download Items Needed</button>
            <button class="btn btn-success" (click)="onDownloadSrcShuttle()">SRC SHUTTLE</button>
          </div>

        </div>

      </div>

    </div>
  </div>
</div>
